// extracted by mini-css-extract-plugin
module.exports = {"atendimentoConsulta":"Consultar_atendimentoConsulta__1yJko","containerPainel":"Consultar_containerPainel__2IP9Z"};